<button mat-button (click)="retryTask()">Retry</button>